import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import { fetchQuestionsForSurveySuccess } from '../actions';

const REQUEST_QUESTIONS = 'requestQuestions';
const REQUEST_ALL_QUESTIONS = 'requestAllQuestions';
const REQUEST_QUESTIONS_BY_GROUP = 'requestQuestionsByGroup';
const REQUEST_QUESTIONS_OF_CLAIM_TYPE_COMBO =
    'requestQuestionsOfClaimTypeCombo';
const REQUEST_QUESTIONS_FOR_SURVEY = 'requestQuestionsForSurvey';

export function requestQuestionsOfClaimTypeCombo(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => {
            const policyTypeCode = action.payload.policyTypeCode
                ? action.payload.policyTypeCode
                : '___';
            const claimCategoryCode = action.payload.claimCategoryCode
                ? action.payload.claimCategoryCode
                : '___';
            const formTypeCode = action.payload.formTypeCode
                ? action.payload.formTypeCode
                : '___';
            const claimApplicationId = action.payload.claimApplicationId;

            return {
                url: `${GENERAL_FUNCTIONS.getBaseURL()}api/question/ClaimApplication/${claimApplicationId}/PolicyTypeCode/${policyTypeCode}/ClaimCategoryCode/${claimCategoryCode}/FormTypeCode/${formTypeCode}`,
                headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
                category: REQUEST_QUESTIONS_OF_CLAIM_TYPE_COMBO,
                method: 'GET',
            };
        });

    let httpResponse$ = sources.HTTP.select(
        REQUEST_QUESTIONS_OF_CLAIM_TYPE_COMBO,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionsOfClaimTypeComboSuccess(response)
                : actions.fetchQuestionsOfClaimTypeComboFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestAllQuestions(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_ALL_QUESTIONS,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/Question`,
            category: REQUEST_ALL_QUESTIONS,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_ALL_QUESTIONS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchAllQuestionsSuccess(response)
                : actions.fetchAllQuestionsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestQuestions(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_QUESTIONS,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => {
            const policyTypeCode = action.payload.policyTypeCode
                ? action.payload.policyTypeCode
                : '___';
            const claimCategoryCode = action.payload.claimCategoryCode
                ? action.payload.claimCategoryCode
                : '___';
            const formTypeCode = action.payload.formTypeCode
                ? action.payload.formTypeCode
                : '___';

            return {
                url: `${GENERAL_FUNCTIONS.getBaseURL()}api/question/PolicyTypeCode/${policyTypeCode}/ClaimCategoryCode/${claimCategoryCode}/FormTypeCode/${formTypeCode}/QuestionGroupStepId/${action.payload.questionGroupStepId}`,
                headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
                category: REQUEST_QUESTIONS,
                method: 'GET',
            };
        });

    let httpResponse$ = sources.HTTP.select(REQUEST_QUESTIONS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionsSuccess(response)
                : actions.fetchQuestionsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestQuestionsByGroup(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/Question/ClaimApplication/${action.payload.claimApplicationId}/Group/${action.payload.groupCode}`,
            category: REQUEST_QUESTIONS_BY_GROUP,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_QUESTIONS_BY_GROUP)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionsByGroupSuccess(response)
                : actions.fetchQuestionsByGroupFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
